import { getMapNode } from "../../content/stages.js";
import { finishNode } from "../run/finishNode.js";
import type { GameState, NodeId } from "../types/index.js";
import { appendLog } from "../run/log.js";
import { accept, reject } from "./reject.js";
import { applyMapEventOffer, resolveMapEvent } from "../events/resolveMapEvent.js";
import { getMapEvent } from "../../content/events.js";

export function openMapEvent(state: GameState, nodeId: NodeId): GameState {
  if (!state.run) return state;
  const result = resolveMapEvent(state.run, nodeId);
  const event = getMapEvent(result.activeEvent.eventId);
  const run = appendLog(
    { ...result.run, currentNodeId: nodeId },
    { phase: 0, kind: "system", message: `イベント「${event.name}」が発生` },
  );
  return accept({
    ...state,
    screen: "event",
    run,
    activeEvent: result.activeEvent,
    resolution: null,
  });
}

function finishMapEvent(state: GameState, accepted: boolean): GameState {
  if (state.screen !== "event" || !state.run || !state.activeEvent) {
    return reject(state, "イベント画面でのみ先へ進める");
  }
  const node = getMapNode(state.run.stageId, state.activeEvent.nodeId);
  if (node?.kind !== "event") return reject(state, "イベントノードがない");

  const event = getMapEvent(state.activeEvent.eventId);
  const applied = accepted
    ? applyMapEventOffer(state.run, state.activeEvent.effects)
    : state.run;
  const logged = appendLog(applied, {
    phase: 0,
    kind: "system",
    message: accepted
      ? `${event.name}を受け入れ：${state.activeEvent.effectText.replaceAll("\n", "、")}`
      : `${event.name}を見送り`,
  });
  const run = finishNode(logged, state.activeEvent.nodeId);
  return accept({ ...state, screen: "map", run, activeEvent: null, resolution: null });
}

export function handleAcceptEvent(state: GameState): GameState {
  return finishMapEvent(state, true);
}

export function handleDeclineEvent(state: GameState): GameState {
  return finishMapEvent(state, false);
}
